// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HYhwf","link":"Header_link__q5P0a","logo-container":"Header_logo-container__yFQZS","logo":"Header_logo__8QyDN"};